<template>
    <SvgIcon v-bind="props" :svg-size="24">
        <template #default>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_646_2613)">
                    <g clip-path="url(#clip1_646_2613)">
                        <path
                            d="M11.9999 22.909C18.0248 22.909 22.909 18.0248 22.909 11.9999C22.909 5.97499 18.0248 1.09082 11.9999 1.09082C5.97499 1.09082 1.09082 5.97499 1.09082 11.9999C1.09082 18.0248 5.97499 22.909 11.9999 22.909Z"
                            stroke="#333330"
                            stroke-width="1.2"
                            stroke-miterlimit="10"
                        />
                        <path
                            d="M11.9824 22.9091C16.2038 22.9091 19.626 18.0249 19.626 12C19.626 5.97505 16.2038 1.09088 11.9824 1.09088C7.761 1.09088 4.33887 5.97505 4.33887 12C4.33887 18.0249 7.761 22.9091 11.9824 22.9091Z"
                            stroke="#333330"
                            stroke-width="1.2"
                            stroke-miterlimit="10"
                        />
                        <path
                            d="M12.0005 22.9091C13.9128 22.9091 15.4629 18.0249 15.4629 12C15.4629 5.97505 13.9128 1.09088 12.0005 1.09088C10.0883 1.09088 8.53809 5.97505 8.53809 12C8.53809 18.0249 10.0883 22.9091 12.0005 22.9091Z"
                            stroke="#333330"
                            stroke-width="1.2"
                            stroke-miterlimit="10"
                        />
                        <path d="M2.92871 5.93939H21.0991" stroke="#333330" stroke-width="1.2" stroke-miterlimit="10" />
                        <path d="M2.92871 17.9427H21.0991" stroke="#333330" stroke-width="1.2" stroke-miterlimit="10" />
                        <path d="M1.09082 11.9406H22.9084" stroke="#333330" stroke-width="1.2" stroke-miterlimit="10" />
                    </g>
                </g>
                <defs>
                    <clipPath id="clip0_646_2613">
                        <rect width="24" height="24" fill="white" />
                    </clipPath>
                    <clipPath id="clip1_646_2613">
                        <rect width="24" height="24" fill="white" />
                    </clipPath>
                </defs>
            </svg>
        </template>
        <template #active>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_646_2608)">
                    <path
                        d="M18.9258 11.1185C18.8348 9.34375 18.4809 7.68805 17.9148 6.24878H15.832C16.0747 7.77462 16.2162 9.44114 16.2466 11.1185H18.9258Z"
                        fill="#333330"
                    />
                    <path
                        d="M11.9901 22.9892C11.9901 22.9892 11.9901 22.9892 12.0002 22.9892C12.6068 22.9784 13.3954 21.604 13.9616 19.2449H10.0186C10.5948 21.6149 11.3733 22.9892 11.9901 23V22.9892Z"
                        fill="#333330"
                    />
                    <path
                        d="M12.0095 1C12.0095 1 12.0095 1 11.9994 1C11.4029 1 10.6345 2.33105 10.0684 4.62522H13.9507C13.3846 2.34187 12.6162 1.01082 12.0197 1H12.0095Z"
                        fill="#333330"
                    />
                    <path
                        d="M9.26988 11.1185H14.7295C14.689 9.28964 14.5171 7.64476 14.2745 6.24878H9.71473C9.47208 7.64476 9.30021 9.28964 9.25977 11.1185H9.26988Z"
                        fill="#333330"
                    />
                    <path
                        d="M14.6182 1.82239C14.972 2.61236 15.2652 3.56466 15.5079 4.62517H17.1356C16.438 3.42398 15.5888 2.45004 14.6182 1.82239Z"
                        fill="#333330"
                    />
                    <path
                        d="M21.7062 17.6111C22.4442 16.1502 22.8992 14.4945 23.0003 12.7414H20.4525C20.3817 14.4837 20.0784 16.1285 19.583 17.6111H21.7163H21.7062Z"
                        fill="#333330"
                    />
                    <path
                        d="M19.5225 6.24878C20.0381 7.73133 20.3515 9.37621 20.4324 11.1185H22.9802C22.8589 9.35457 22.3837 7.70969 21.6254 6.24878H19.5225Z"
                        fill="#333330"
                    />
                    <path
                        d="M8.49145 4.62594C8.7341 3.55461 9.03741 2.59149 9.39127 1.80151C8.40046 2.42916 7.53097 3.40311 6.82324 4.62594H8.49145Z"
                        fill="#333330"
                    />
                    <path
                        d="M18.8553 4.62532H20.6044C19.4417 3.07784 18.239 2.75727 16.5 1.99976C17.5414 2.89795 18.1476 3.18605 18.8553 4.62532Z"
                        fill="#333330"
                    />
                    <path
                        d="M14.7291 12.7414H9.26953C9.29986 14.5702 9.46163 16.2043 9.70428 17.6111H14.3045C14.537 16.2043 14.6988 14.5702 14.7392 12.7414H14.7291Z"
                        fill="#333330"
                    />
                    <path
                        d="M2.36455 6.24878C1.60628 7.70969 1.13109 9.36539 1.00977 11.1185H3.52724C3.60813 9.37621 3.92155 7.73133 4.43717 6.24878H2.37466H2.36455Z"
                        fill="#333330"
                    />
                    <path
                        d="M3.51748 12.7414H1C1.1011 14.4945 1.54596 16.1502 2.29412 17.6111H4.38697C3.89156 16.1285 3.57814 14.4837 3.51748 12.7414Z"
                        fill="#333330"
                    />
                    <path
                        d="M5.04429 11.1185H7.75386C7.7943 9.44114 7.92574 7.77462 8.16839 6.24878H6.04521C5.47903 7.68805 5.12517 9.34375 5.03418 11.1185H5.04429Z"
                        fill="#333330"
                    />
                    <path
                        d="M5.10548 4.6251C5.80309 3.19666 6.46874 2.39837 7.5 1.50018C5.79135 2.26851 4.5393 3.09926 3.38672 4.6251H5.10548Z"
                        fill="#333330"
                    />
                    <path
                        d="M5.04464 19.2344H3.30566C4.45824 20.8252 5.7408 21.2101 7.5 22.0001C6.43841 21.0802 5.75237 20.7278 5.05475 19.2344H5.04464Z"
                        fill="#333330"
                    />
                    <path
                        d="M18.9156 19.2344C18.2079 20.7386 17.5717 21.0802 16.5 22.0001C18.2794 21.2101 19.5324 20.836 20.695 19.2344H18.9156Z"
                        fill="#333330"
                    />
                    <path
                        d="M18.9255 12.7414H16.2462C16.2159 14.4187 16.0844 16.0853 15.8418 17.6111H17.9549C18.5008 16.1718 18.8446 14.5161 18.9255 12.7414Z"
                        fill="#333330"
                    />
                    <path
                        d="M6.00477 17.6111H8.15828C7.91563 16.0853 7.78419 14.4187 7.75386 12.7414H5.03418C5.11506 14.5161 5.4487 16.1718 6.00477 17.6111Z"
                        fill="#333330"
                    />
                    <path
                        d="M9.39173 22.1887C9.01765 21.3555 8.71434 20.3491 8.46158 19.2344H6.75293C7.47076 20.5222 8.37059 21.5394 9.39173 22.1887Z"
                        fill="#333330"
                    />
                    <path
                        d="M15.5382 19.2344C15.2956 20.3382 14.9922 21.3338 14.6182 22.1671C15.6191 21.5178 16.5088 20.5006 17.2064 19.2344H15.5382Z"
                        fill="#333330"
                    />
                    <path
                        d="M11.91 22.82C17.93 22.82 22.82 17.94 22.82 11.91C22.82 5.88 17.93 1 11.91 1C5.89 1 1 5.88 1 11.91C1 17.94 5.88 22.82 11.91 22.82Z"
                        stroke="#333330"
                        stroke-width="1.2"
                        stroke-miterlimit="10"
                    />
                </g>
                <defs>
                    <clipPath id="clip0_646_2608">
                        <rect width="24" height="24" fill="white" />
                    </clipPath>
                </defs>
            </svg>
        </template>
    </SvgIcon>
</template>

<script lang="ts" setup>
    import SvgIcon from '@navbar-common/ui/SvgIcon.vue';
    import {commonIconProps} from '@navbar-logged/common/icons/common-props';

    const props = defineProps(commonIconProps);
</script>
